export const endpoints = {
  byCode: '/tenant/code/:code',
}
